import { DataLayer } from "@grandvisionhq/analytics";
import { myAccountEventType } from "./types.js";
const logMyOrdersClickEvent = (position) => {
  DataLayer.pushEvent({
    event_type: myAccountEventType,
    event: "my_online_orders_click",
    order: {
      button: position
    }
  });
};
export {
  logMyOrdersClickEvent
};
//# sourceMappingURL=my-orders-click.js.map
